/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCollisionDeductable32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <g>
        <mask
          id='collision-deductable-32_svg__a'
          width={30}
          height={20}
          x={1}
          y={0}
          maskUnits='userSpaceOnUse'
        >
          <path
            fill='#C4C4C4'
            fillRule='evenodd'
            d='M30.75.5H1.25L5 12.5l3 5L20 20l.024-1.605 5.878-9.641L27 13 30.75.5z'
          />
        </mask>
        <g mask='url(#collision-deductable-32_svg__a)'>
          <path
            stroke='currentColor'
            strokeMiterlimit={5}
            strokeWidth={1.5}
            d='M15.593 7.374l2.282 5.319 6.222-2.445-2.996 5.077 6.519 1.861L21.1 19.05l2.996 5.076-6.222-2.444L15.593 27 13.31 21.68 7.09 24.125l2.996-5.076-6.519-1.863 6.519-1.861-2.996-5.077 6.222 2.445 2.282-5.319z'
          />
        </g>
        <path
          stroke='currentColor'
          strokeLinecap='square'
          strokeMiterlimit={5}
          strokeWidth={1.5}
          d='M17.5 28v-3.204c0-1.122.56-2.17 1.494-2.793C20.304 21.13 22 19.997 22 19.997v-.396a5.101 5.101 0 015.101-5.101h7.154a2.71 2.71 0 012.467 1.588l1.778 3.91 3.81 1.633a5.266 5.266 0 013.19 4.84v1.486L17.5 28z'
        />
        <path
          stroke='currentColor'
          strokeMiterlimit={5}
          strokeWidth={1.5}
          d='M29.918 14.5v6.096M21.5 20h17'
        />
        <path
          fill='#fff'
          stroke='currentColor'
          strokeLinejoin='round'
          strokeMiterlimit={5}
          strokeWidth={1.5}
          d='M23.805 30.457a2.5 2.5 0 100-5 2.5 2.5 0 000 5z'
        />
        <path
          stroke='currentColor'
          strokeLinecap='square'
          strokeMiterlimit={5}
          strokeWidth={1.5}
          d='M-13 28v-3.456c0-.98.428-1.911 1.171-2.549l2.329-1.998v-.396A5.101 5.101 0 01-4.399 14.5h6.29a2.71 2.71 0 012.38 1.412L6.5 19.997l6.438 2.417a2.408 2.408 0 011.562 2.255v3.288L-13 28v0z'
        />
        <path
          stroke='currentColor'
          strokeMiterlimit={5}
          strokeWidth={1.5}
          d='M10.793 23.759h3.206M-10 20H6.5'
        />
        <path
          fill='#fff'
          stroke='currentColor'
          strokeLinejoin='round'
          strokeMiterlimit={5}
          strokeWidth={1.5}
          d='M7.305 30.457a2.5 2.5 0 100-5 2.5 2.5 0 000 5z'
        />
        <path
          stroke='currentColor'
          strokeMiterlimit={5}
          strokeWidth={1.5}
          d='M.5 31h31'
        />
      </g>
      <defs>
        <clipPath id='collision-deductable-32_svg__clip0'>
          <path fill='#fff' d='M0 0h32v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCollisionDeductable32;
